import React from 'react';
import HeroBanner from '../Component/Home/HeroBanner';
import HomeCategory from '../Component/Home/HomeCategory';
import FreshArrivals from '../Component/Home/FreshArrivals';
// import ArrivalBox from '../Component/Home/ArrivalBox';
// import Blog from '../Component/Home/Blog';
import Shipping from '../Component/Home/Shipping';
import MiddHeroBanner from '../Component/Home/MiddHeroBanner';

const HomeIndex = () => {
 return(
    <> 
      <HeroBanner/>
      <HomeCategory/>
      <FreshArrivals/>
      {/* <ArrivalBox/> */}
      <MiddHeroBanner/>
      {/* <Blog/> */}
      <Shipping/>
   </>
 )
}
export default HomeIndex;